import React, { useState, useEffect } from 'react';
import {
    Box, Card, CardContent, Typography, Autocomplete, TextField, Button, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress
} from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../../App';
import * as XLSX from 'xlsx';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';

const ServiceDashborde = () => {
    const [reportType, setReportType] = useState(null);
    const [branchList, setBranchList] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [dealerList, setDealerList] = useState([]);
    const [selectedDealer, setSelectedDealer] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const login_id = localStorage.getItem("LOGIN_ID");
    const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");


	const headerStyle = {
	  backgroundColor: '#ADD8E6',
	  color: 'black',
	  fontWeight: 'bold'
	};
	
	
	const formatHeader = (key) => {
	  return key
		.replace(/_/g, ' ')         // Replace underscores with spaces
		.toLowerCase()              // Make everything lowercase
		.replace(/\b\w/g, c => c.toUpperCase()); // Capitalize first letter of each word
	};


    useEffect(() => {
        handleView();
    }, []);



   const handleView = async () => {
		  setLoading(true);
		  setShowTable(false);

		  try {
			const res = await axios.post(`${BASE_URL}/getServiceDashboadeData`, {
			  branch: BRANCH_CODE,
			  login_id: login_id
			});

			const rawData = res.data.data;

			if (!rawData || rawData.length === 0) {
			  Swal.fire('No Data', 'No records found for the selected criteria', 'info');
			} else {
			  setData(rawData); // No need to transform
			  setShowTable(true);
			}

		  } catch (error) {
			console.error('Error fetching report', error);
			Swal.fire('Error', 'Failed to fetch data', 'error');
		  } finally {
			setLoading(false);
		  }
		};


    const getStatusColor = (status) => {
        if (!status) return '#000000 !important';
        const normalizedStatus = String(status).trim().toLowerCase();
        
        switch (normalizedStatus) {
            case 'accounted': 
            case 'a': return '#4CAF50 !important'; 
            case 'pending': 
            case 'p': return '#FFC107 !important'; 
            case 'rejected': 
            case 'r': return '#F44336 !important'; 
            default: return '#000000 !important';  
        }
    };

    const exportToExcel = async () => {
        if (data.length === 0) {
            Swal.fire('No Data', 'No records to export', 'info');
            return;
        }

        const confirmResult = await Swal.fire({
            title: 'Confirm Export',
            text: 'Do you want to download the report as Excel?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, Download',
            cancelButtonText: 'Cancel'
        });

        if (!confirmResult.isConfirmed) {
            return;  
        }

        Swal.fire({
            title: 'Exporting...',
            text: 'Please wait while the Excel file is being prepared.',
            icon: 'info',
            showConfirmButton: false,
            allowOutsideClick: false,
            willOpen: () => {
                Swal.showLoading();
            }
        });

        setTimeout(() => {
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Service Claims");
            XLSX.writeFile(workbook, 'Defective_Sets_Status.xlsx');

            Swal.close();
            Swal.fire('Success', 'Excel file exported successfully', 'success');
        }, 1500); 
    };
    


    return (
        <Box sx={{ p: 3 }}>
		  <Typography
                variant="h4"
                sx={{
                    color: '#2E86C1',
                    mb: 3,
                    textAlign: 'left'
                }}
            >
                Defective Sets Status
            </Typography>
            <Card>
                <CardContent>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
						<Button
							variant="contained"
							color="success"
							onClick={exportToExcel}
							sx={{ height: 56 }}
							startIcon={<DownloadIcon />}  
						>
							Export to Excel
						</Button>
                    </Box>

                    {loading && <CircularProgress />}

                    {showTable && data.length > 0 && (
					  <TableContainer component={Paper} sx={{ maxHeight: 500, overflowY: 'auto' }}>
						<Table stickyHeader>
						  <TableHead>
							<TableRow>
							  {Object.keys(data[0]).map((key) => (
								<TableCell key={key} sx={headerStyle}>
								  {formatHeader(key)}
								</TableCell>
							  ))}
							</TableRow>
						  </TableHead>

						  <TableBody>
							{data.map((item, rowIndex) => (
							  <TableRow key={item.DOC_NO || `${item.MAT_CODE}-${item.SERIAL_NO}-${rowIndex}`}>
								{Object.keys(item).map((key) => (
								  <TableCell key={key}>
									{key === 'STATUS' ? (
									  <span style={{
										color: getStatusColor(item[key]).replace(' !important', ''),
										fontWeight: 'bold'
									  }}>
										{item[key]}
									  </span>
									) : (
									  item[key]
									)}
								  </TableCell>
								))}
							  </TableRow>
							))}
						  </TableBody>
						</Table>
					  </TableContainer>
					)}
          </CardContent>
     </Card>
</Box>
   );
}
export default ServiceDashborde;
